// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mw-0";
export var assigneeDetails = "_mw-1";
export var assigneeInfo = "_mw-2";
export var dropdownContainer = "_mw-4";
export var dropdownImage = "_mw-5";
export var editAssigneeInfo = "_mw-3";
export var editAssigneeModalContainer = "_mw-6";
export var hidden = "_mw-8";
export var input = "_mw-7";